/// <reference path="../../../../../shared/utils/Helper.ts"/>
/// <reference path="../../../../../shared/utils/Ajax.ts"/>
/// <reference path="../../../../../shared/models/generated/MitgliedschaftAnlageResponseApi.d.ts"/>

import { AppUtils } from '../../../../../shared/utils/index';
import { AppPersistenceService } from './AppPersistenceService';
import { BasicApplicationUrlBuilder } from "../../../../../shared/services/BasicApplicationUrlBuilder";
import { ContractInfoApi } from '../../../../../shared/models/generated/PersonContractInfoApi';
import { SimulationTypeApi } from '../../../../../shared/models/generated/TypesSimulationTypeApi';
import { AppModelAdapter } from '../helper/AppModelAdapter';
import { MglBasisAnlage } from '../../../../../shared/models/api/MglBasisAnlage';
import { MglAnlage } from '../../../../../shared/models/api/MglAnlage';
import { ProfiwerberViewModelApi } from '../../../../../shared/models/generated/MitgliedschaftProfiwerberViewModelApi';
import { MitgliedschaftGutscheinApi } from '../../../../../shared/models/generated/MitgliedschaftMitgliedschaftGutscheinApi';
import { MitgliedschaftPdfBestaetigungV2Api } from '../../../../../shared/models/generated/MitgliedschaftMitgliedschaftPdfBestaetigungV2Api';
import { ModelAdapter } from '../../../../../shared/models/adapter/ModelAdapter';
import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { PersonalDataModel } from '../../../../../shared/models/view/PersonalData';
import { EmpfehlungsantragVermerkenRequestApi } from '../../../../../shared/models/generated/FreundschaftsWerbungEmpfehlungsantragVermerkenRequestApi';

export class AppApiService {
	private readonly clientKey = "mglmailconfirmationclient";
	private readonly options: MglModularSystemV2AppOptions;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<MglModularSystemV2AppDefinition>;
	//private api: string;
	//private client: string;

	constructor(options: MglModularSystemV2AppOptions) {
		this.options = options;
		this.appPersistenceService = new AppPersistenceService(options);
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(options);
		this.setApiConfiguration();
	}

	public submitEnclosure(reqModel: MglBasisAnlage,
		advertisingConsentModel: AdvertisingConsentModel,
		successCallback: (data: ApiResponse<AnlageResponseApi>, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void,
		onlyValidate: SimulationTypeApi): void {

		T.Utils.View.startLoader();

		const url = T.Utils.Helper.appendURIPath(T.Utils.Application.getApi(), this.getApiMembershipUrl(this.options.app.rate));

		// Provisionsnummer / Agenturnummer
		reqModel.Agenturnummer = Number(this.options.app.agencynumber);

		reqModel.SimulationType = onlyValidate;

		reqModel.Bankdaten.BankEinzugMitglied = true;

		if (reqModel instanceof MglAnlage) {
			reqModel.Englisch = this.options.app.isenglish;
		}

		if (advertisingConsentModel) {
			const personalDataModel = new PersonalDataModel();

			personalDataModel.Email = reqModel.Antragssteller.Email;
			personalDataModel.TelefonVorwahl = reqModel.Antragssteller.Telefon.Prefix;
			personalDataModel.TelefonNummer = reqModel.Antragssteller.Telefon.Suffix;
			personalDataModel.TelefonGeschaeftlichVorwahl = reqModel.Antragssteller.TelGesch.Prefix;
			personalDataModel.TelefonGeschaeftlichNummer = reqModel.Antragssteller.TelGesch.Suffix;
			reqModel.Consent = ModelAdapter.getConsentWriteShortModelApi(advertisingConsentModel, personalDataModel, this.options.app.originindicator, reqModel.Consent ? reqModel.Consent.Version : undefined);
		}

		const options = {
			method: 'POST',
			url: url,
			data: JSON.stringify(reqModel.toRequestObject())
		};

		AppUtils.Ajax.fragment(options, successCallback, errorCallback);
	}

	public callApiMailConfirmation(requestModel: MitgliedschaftPdfBestaetigungV2Api): void {
		//Email	- Email an welche die Police gesendet wird
		//Attachments - Liste von IDs der PDFs welche als Attachment an das Usermail gehängt werden
		//MglToken - Token der vorausgegangenen Mitgliedschaftsanlage.
		//HtmlFragment - Html Fragment das ins Pdf gerendert werden soll

		if (requestModel.MglToken && requestModel.MglToken !== "") {
			T.Utils.ClientAuth.authorize(this.clientKey, () => {
				AppUtils.Ajax.fragment({
					method: 'POST',
					xhrFields: { withCredentials: true },
					url: this.applicationUrlBuilder.fullUrl(this.options.app.apimailconfirmation),
					data: JSON.stringify(requestModel.toRequestObject())
				}, () => {
					//NOSONAR
				}, (jqxhr: JQueryXHR) => {
					AppUtils.Helper.logError(jqxhr, 'MglEnclosureApplication', window.location.href, `_callApiMailConfirmation ${T.Utils.Application.getApi()}${this.options.app.apimailconfirmation}`);
				});
			}, () => {
				//NOSONAR
			});
		}
	}

	public getUserIpAdress(successCallback: (data: { IP: string }, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			dataType: "json",
			headers: {
				'Ocp-Apim-Subscription-Key': T.Utils.Application.getApiMSubscriptionKey()
			},
			url: this.applicationUrlBuilder.fullApimUrl(this.options.app.apirequestcontextip)
		}, successCallback, errorCallback);
	}

	public getWalletAppUrl(mglToken: string, successCallback: (data: ApiResponse<UrlResponseModelApi>) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): JQueryXHR {
		return AppUtils.Ajax.fragment({
			method: 'GET',
			data: {
				tag: "mitgliedschaft",
				mglToken
			},
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apiwalleturl)
		}, successCallback, errorCallback);
	}

	public getWalletQrCode(mglToken: string, successCallback: (data: ApiResponse<QrCodeResponseModelApi>) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): JQueryXHR {
		return AppUtils.Ajax.fragment({
			method: 'GET',
			data: {
				tag: "mitgliedschaft",
				mglToken
			},
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apiwalletqrcode)
		}, successCallback, errorCallback);
	}

	public checkAdvertisingAllowed(successCallback: (data: ApiResponse<boolean>) => void, errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {
		T.Utils.Auth.getBearerToken((token: string) => {
			AppUtils.Ajax.fragment({
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`
				},
				url: this.applicationUrlBuilder.fullUrl(this.options.app.apicheckadvertising)
			}, successCallback, errorCallback);
		});
	}

	private getApiMembershipUrl(rate: string): string {
		if (this.options.app.issalesman) {
			return this.options.app.apisalesman;
		} else if (AppModelAdapter.isYoungGenerationRate(rate)) {
			return this.options.app.apimembershipyounggeneration;
		}

		return this.options.app.apimembership;
	}

	private getApiMglTarifArgs(rate: string): JQuery.AjaxSettings {
		const args = {
			url: T.Utils.Application.getApi(),
			async: false,
			method: "GET"
		};

		if (AppModelAdapter.isYoungGenerationRate(rate)) {
			args.method = "POST";
			args.url = T.Utils.Helper.appendURIPath(args.url, this.options.app.apimglrateyounggeneration);
			return args;
		}

		args.url = T.Utils.Helper.appendURIPath(args.url, this.options.app.apimglrate);
		return args;
	}

	public makeRateRequest(options: JQuery.AjaxSettings,
		successCallback: (data: ApiResponse<ContractInfoApi>, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {
		let args = this.getApiMglTarifArgs(this.options.app.rate.toString());
		args = $.extend({}, args, options);

		if (args.method === "POST") {
			args.data = JSON.stringify(args.data);
		}
		AppUtils.Ajax.fragment(args, successCallback, errorCallback);
	}

	public makeStartOfMembershipRequest(startdate: string,
		successCallback: () => void,
		errorCallback: () => void): void {
		const appModel = this.appPersistenceService.getApplicationModel();

		const options = {
			method: 'POST',
			async: false,
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apistartofmembership),
			data: JSON.stringify({
				"Tarif": appModel.Tarif.Tarif,
				"Beginn": startdate
			})
		};

		AppUtils.Ajax.fragment(options, successCallback, errorCallback);
	}

	public getProcessId(formId: string, successCallback: (data: ApiResponse<string>) => void, errorCallback: () => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: AppUtils.Url.updateUrlParameter({ FormId: formId }, this.applicationUrlBuilder.fullUrl(this.options.app.apiprocessid))
		}, successCallback, errorCallback);
	}

	public checkSalesmanNumbers(
		reqModel: ProfiwerberViewModelApi,
		successCallback: () => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const options = {
			method: 'POST',
			url: T.Utils.Helper.appendURIPath(T.Utils.Application.getApi(), this.options.app.apisalesmancheck),
			data: reqModel.toJsonString()
		};

		AppUtils.Ajax.fragment(options, successCallback, errorCallback);
	}

	/**
	 * api/mitgliedschaftgutschein/pruefen
	 */
	public checkBonuscode(bonuscode: MitgliedschaftGutscheinApi,
		successCallback: (data: ApiResponse<boolean>, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {
		const options = {
			method: 'POST',
			url: T.Utils.Helper.appendURIPath(T.Utils.Application.getApi(), this.options.app.apicheckbonuscode),
			data: JSON.stringify(bonuscode.toRequestObject())
		};

		AppUtils.Ajax.fragment(options, successCallback, errorCallback);
	}

	private setApiConfiguration(): void {
		T.Utils.Application.init();
	}

	public static isYoungGenerationRate(rate: string): boolean {
		return -1 < AppModelAdapter.YOUNG_GENERATION_RATES.indexOf(rate);
	}

	public createAdacPayToken(data: { Wbs: string, Token: string },
		successCallback: (data: ApiResponse<string>, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apiadacpay),
			data: data
		}, successCallback, errorCallback);
	}

	public checkMglWbs(wbs: string, successCallback: (data: ApiResponse<QrCodeResponseModelApi>) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): JQueryXHR {
		return AppUtils.Ajax.fragment({
			method: 'GET',
			data: {
				werbeschluessel: wbs
			},
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apicheckmglwbs)
		}, successCallback, errorCallback);
	}

	public resolveFriendshipRecommendation(recommendation: string, successCallback: (data: ApiResponse<QrCodeResponseModelApi>) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): JQueryXHR {
		return AppUtils.Ajax.fragment({
			method: 'GET',
			data: {
				empfehlungsId: recommendation
			},
			xhrFields: { withCredentials: true },
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apigetrecommendationdata)
		}, successCallback, errorCallback);
	}

	public submitRecommendationApplicationNote(requestModel: EmpfehlungsantragVermerkenRequestApi): void {
		AppUtils.Ajax.fragment({
			method: 'POST',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apirecommendationapplicationnote),
			data: JSON.stringify(requestModel.toRequestObject())
		});
	}

	public makeEncryptionCall(
		apiUrl: string,
		successCallback: (data: ApiResponse<string>, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, apiurl: string, textStatus?: string, errorThrown?: string) => void,): void {



		AppUtils.Ajax.fragment({
			method: 'GET',
			url: apiUrl
		}, successCallback, errorCallback);
	}

}
